import { Box, Typography } from "@mui/material";
import type React from "react";
import { Spacing } from "../types/enum";

interface Props {
  title: string;
  /** What the page is for, in a sentence or two. Optional, but most pages want one. */
  children?: React.ReactNode;
  /** Buttons that belong to the page as a whole, kept on the right of the title. */
  actions?: React.ReactNode;
}

/**
 * The heading every screen opens with.
 *
 * Exists so the pages can't drift apart: they were each rolling their own and
 * had ended up with the description at five different widths, and one at the
 * wrong size entirely. A page shouldn't have to remember the house style.
 */
const PageHeader: React.FC<Props> = ({ title, children, actions }) => (
  <Box
    mb={Spacing.m}
    display="flex"
    alignItems="flex-start"
    justifyContent="space-between"
    gap={Spacing.m}
    flexWrap="wrap"
  >
    <Box>
      <Typography variant="h3" color="textPrimary">
        {title}
      </Typography>
      {children ? (
        // Capped so a long description stays a readable column rather than
        // running the full width of a wide screen.
        <Typography variant="body1" color="textSecondary" mt={Spacing.s} maxWidth="66ch">
          {children}
        </Typography>
      ) : null}
    </Box>

    {actions ? (
      <Box display="flex" alignItems="center" gap={Spacing.sm} flexShrink={0}>
        {actions}
      </Box>
    ) : null}
  </Box>
);

export default PageHeader;
